import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const shouldShowListMembershipError = triggers => {
  return !!(triggers && triggers.filterBranches.some(filterBranch => filterBranch.filters.length > 1 && filterBranch.filters.some(filter => !!filter.listId)));
};
const splitGroupedListMembershipFilters = rootFilterBranch => rootFilterBranch.filterBranches.reduce((stagedFilterBranchPartition, filterBranch) => {
  if (filterBranch.filters.length <= 1 || filterBranch.filters.every(filter => !filter.listId)) {
    stagedFilterBranchPartition[0].push(filterBranch);
  } else {
    stagedFilterBranchPartition[1].push(filterBranch);
  }
  return stagedFilterBranchPartition;
}, [[], []]);
const filterBranchesToRootFilterBranch = filterBranches => ({
  filterBranchOperator: 'OR',
  filterBranchType: 'OR',
  filters: [],
  filterBranches
});
const ListMembershipErrorBanner = ({
  stagedChanges,
  setStagedChanges
}) => {
  const handleSplitListMembershipFilters = () => {
    const [filterBranchesToKeep, filterBranchesToSplit] = splitGroupedListMembershipFilters(stagedChanges.triggers);
    const splitFilterBranches = [];
    filterBranchesToSplit.forEach(filterBranch => {
      filterBranch.filters.forEach(filter => {
        splitFilterBranches.push({
          filterBranches: [],
          filterBranchOperator: 'AND',
          filterBranchType: 'AND',
          filters: [filter]
        });
      });
    });
    setStagedChanges(Object.assign({}, stagedChanges, {
      triggers: filterBranchesToRootFilterBranch(filterBranchesToKeep.concat(splitFilterBranches))
    }));
  };
  const handleMoveListMembershipFilters = () => {
    const [filterBranchesToKeep, filterBranchesToSplit] = splitGroupedListMembershipFilters(stagedChanges.triggers);
    const newRefinementCriteriaFilterBranches = stagedChanges.refinementCriteria ? stagedChanges.refinementCriteria.filterBranches.concat(filterBranchesToSplit) : filterBranchesToSplit;
    setStagedChanges(Object.assign({}, stagedChanges, {
      refinementCriteria: filterBranchesToRootFilterBranch(newRefinementCriteriaFilterBranches),
      triggers: filterBranchesToRootFilterBranch(filterBranchesToKeep)
    }));
  };

  /* can't move to refinement criteria if it's empty due to UI bug on SegmentationFilters side
  where if the editor is in the empty/"add filters", value can't be updated externally. Hopefully temporary  */
  const isRefinementCriteriaEmpty = !stagedChanges.refinementCriteria || !stagedChanges.refinementCriteria.filterBranches.length;
  const isLastTrigger = stagedChanges.triggers.filterBranches.length === 1;
  return /*#__PURE__*/_jsxs(UIAlert, {
    type: "danger",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.enrollExistingPanel.listMembershipBanner.header"
    }),
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.enrollExistingPanel.listMembershipBanner.paragraph1"
    }), /*#__PURE__*/_jsx(View, {
      marginBlock: "200",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.enrollExistingPanel.listMembershipBanner.paragraph2"
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      inline: true,
      childClassName: "m-y-1",
      children: [/*#__PURE__*/_jsx(UIButton, {
        onClick: handleSplitListMembershipFilters,
        size: "sm",
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollExistingPanel.listMembershipBanner.splitButton"
        })
      }), /*#__PURE__*/_jsx(UITooltip, {
        title: isRefinementCriteriaEmpty ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollExistingPanel.listMembershipBanner.refinementCriteriaDisabledMessage"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollExistingPanel.listMembershipBanner.lastTriggersDisabledMessage"
        }),
        placement: "bottom",
        children: /*#__PURE__*/_jsx(UIButton, {
          onClick: handleMoveListMembershipFilters,
          disabled: isRefinementCriteriaEmpty || isLastTrigger,
          size: "sm",
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.redesign.enrollExistingPanel.listMembershipBanner.moveButton"
          })
        })
      })]
    })]
  });
};
export default ListMembershipErrorBanner;